import { Component, forwardRef, input, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, AbstractControl, FormControl } from '@angular/forms';
import { ValidationHelper } from '../../helpers/validation.helper';
import { retry } from 'rxjs';

@Component({
  selector: 'text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true,
    },
  ],
})
export class TextInputComponent implements ControlValueAccessor {

  @Input() controller: AbstractControl;
  @Input() label: string;
  @Input() required: boolean;
  @Input() pattern: string;
  @Input() customError: string;
  @Input() isTextarea: boolean;
  @Input() rows: number = 5;
  @Input() type : string = 'text';
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;

  value: any = '';
  onChange = (_: any) => { };
  onTouched = () => { };

  get formControl(): FormControl {
    return this.controller as FormControl;
  }

  get controllerName(): string {
    return Object.keys(this.controller.parent.controls).find(
      (key) => this.controller.parent.get(key) === this.controller
    ) || '';
  }

  checkControllerErrors() {
    return ValidationHelper.checkControllerErrors(this.controller)
  }

  writeValue(value: any) {
    if (value !== undefined) {
      this.formControl.setValue(value);
    }
  }
  propagateChange = (_: any) => { };
  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched() { }
  setDisabledState?(isDisabled: boolean): void {
  }

}
